import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import React from 'react';

export default function DraggableDialogPaperComponent (props) {
  return (
    <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}